import { AccesoEstado } from "../../common/enumModel";
import { EquipoModel } from "../../solicitud/EquipoModel";
import { VehiculoModel } from "../../solicitud/VehiculoModel";

export class AccesoModel {
    idAccesoPersonal: number;
    nombres:string;
    apellidoPaterno:string;
    apellidoMaterno:string;
    nroDocumentoIdentidad: string;
    cargo: string;
    idEstado: AccesoEstado;
    estado: string;
    documentos: Array<Documento>;
    solicitudEquipos: Array<EquipoModel>;
    solicitudVehiculos: Array<VehiculoModel>;
    solicitudDocumentosTecnicos: Array<DocumentoTecnico>;
    idSolicitud: number;
    codigoSolicitud: string;
    fechaInicio: Date;
    fechaFin: Date;

    constructor(){
        this.idAccesoPersonal = 0;
        this.nombres = '';
        this.apellidoPaterno = '';
        this.apellidoMaterno = '';
        this.nroDocumentoIdentidad = '';
        this.cargo = '';
        this.idEstado = AccesoEstado.AUTORIZADO;
        this.estado = '';
        this.documentos = new Array<Documento>();
        this.solicitudEquipos = new Array<EquipoModel>();
        this.solicitudVehiculos = new Array<VehiculoModel>();
        this.solicitudDocumentosTecnicos = new Array<DocumentoTecnico>();
        this.idSolicitud = 0;
        this.codigoSolicitud = '';
        this.fechaInicio = new Date();
        this.fechaFin = new Date();
    }
}

export class Documento {
    solicitudDocumentoRequerido: string;
    requisito: string;
    fechaVencimiento: Date;
    nombreArchivo: string;
    idSolicitudPersonaDocumento: number;
    idSolicitudPersona: number;
    permiteVisor: boolean;
    constructor(){
        this.solicitudDocumentoRequerido = '';
        this.requisito = '';
        this.fechaVencimiento = new Date();
        this.nombreArchivo = '';
        this.idSolicitudPersonaDocumento = 0;
        this.idSolicitudPersona = 0;
        this.permiteVisor = false;
    }
}

export class DocumentoTecnico {
    // solicitudDocumentoRequerido: string;
    requisito: string;
    fechaVencimiento: Date;
    nombreArchivo: string;
    idSolicitudDocumentoTecnico: number;
    idSolicitud: number;
    documento: string;
    permiteVisor: boolean;

    constructor(){
        // this.solicitudDocumentoRequerido = '';
        this.requisito = '';
        this.fechaVencimiento = new Date();
        this.nombreArchivo = '';
        this.idSolicitudDocumentoTecnico = 0;
        this.idSolicitud = 0;
        this.documento = '';
        this.permiteVisor = false;
    }
}